import { http } from "@/composable/httpService";
import { defineStore } from "pinia";
import { computed } from "vue";
import { ref } from "vue";

export const useGetBannersStore = defineStore("getBannersStore", () => {
  const banners = ref([]);
  const loadingBanners = ref(false);
  const sidePanelBanners = ref([]);
  const loadingSorting = ref(false);
  const message = ref("");

  const filterBanners = computed(() => banners.value);

  const sortingBanners = computed(() => sidePanelBanners.value.map((banner, index) => {
    return {
      id: banner.id,
      sort: index + 1,
    };
  }));

  const handleFetchBanners = (params = null) => {
    loadingBanners.value = true;
    banners.value = [];
    sidePanelBanners.value = [];
    http()
      .get("/v3/banners", { params })
      .then(({ data }) => {
        banners.value = structuredClone(data.data);
        sidePanelBanners.value = structuredClone(data.data);
      })
      .catch((error) => console.error("Error fetching banners:", error))
      .finally(() => (loadingBanners.value = false));
  };

  const handleSortBanners = () => {
    loadingSorting.value = true;
    http().put('/v3/banners/sort', {
      banners: sortingBanners.value,
    }).then(({ data }) => {
      message.value = data.message;
    }).catch((error) => console.error("Error sorting banners:", error))
    .finally(() => loadingSorting.value = false)
  }

  return {
    banners,
    sortingBanners,
    loadingBanners,
    sidePanelBanners,
    filterBanners,
    loadingSorting,
    message,
    handleSortBanners,
    handleFetchBanners,
  };
});
